const articleQuote = () => {
  const prefix = `article_quote`,
    component = document.querySelectorAll(`.${prefix}`);

  if (exists(`.${prefix}`)) {
    const createIcon = (componentIndex) => {
      const icon = new Element({
        type: 'span',
        classes: [
          `quotation_blob`,
        ],
        attributes: [
          [`data-quotation-blob-min`, 1],
          [`data-quotation-blob-max`, 2],
        ],
        append: {
          parent: componentIndex,
          before: componentIndex.childNodes[0]
        }
      })
    };

    const person = (componentIndex) => {
      const name = componentIndex.getAttribute('data-name'),
        job = componentIndex.getAttribute('data-credit'),
        link = componentIndex.getAttribute('data-link');
      
      let credit;

      const outputName = (parent) => {
        if (name) {
          credit = new Element({
            type: 'h5',
            classes: [
              `heading--body_title`,
              `article_quote-credit`,
            ],
            content: name,
            append: {
              parent: parent,
            },
          });
        }
      };

      const outputJob = (parent) => {
        if (job) {
          new Element({
            type: 'span',
            content: ` - ${job}`,
            append: {
              parent: parent,
            },
          });
        }
      };

      if (link) {
        const container = new Element({
          type: 'a',
          href: link,
          attributes: [
            ['target', '_blank'],
          ],
          append: {
            parent: componentIndex
          }
        });
        outputName(container);
        outputJob(componentIndex);
      } else {
        outputName(componentIndex);
        outputJob(credit);
      }
    };

    for (let i = 0; i < component.length; i++) {
      const componentIndex = component[i];
      createIcon(componentIndex);
      person(componentIndex);
    }
  }
}
articleQuote();